import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { useClinicSelector } from 'src/hooks/useAsyncSelector';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { Header } from 'src/components/Header';
import { useExit } from 'src/hooks/useExit';

type Props = {
    title: string;
    description?: string
}

export function ErrorPage({ title, description }: Props) {
    const { data: clinic } = useClinicSelector();
    const exit = useExit();

    return (
        <div className='flex flex-col min-h-dvh pb-[env(safe-area-inset-bottom, 0)]'>
            <Header />
            <div className="relative">
                <main className='max-w-lg mx-auto px-5 pt-12 pb-4 lg:pb-12 flex flex-1 flex-col'>
                    <ContentContainer className='flex-1 lg:flex-none space-y-6 text-center'>
                        <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
                        <h1 className="text-2xl text-gray-900 font-medium">
                            {title}
                        </h1>
                        <p>
                            {description}
                        </p>
                        {clinic && <p>
                            Please book an in-clinic appointment instead, or call our reception
                            {clinic.phoneNumber ? `on ` : ''} <a className="text-primary" href={`tel:${clinic.phoneNumber}`}>{clinic.phoneNumber} </a>
                            for further assistance.
                        </p>}
                    </ContentContainer>
                    <StickyBottomBar>
                        <Button
                            className="flex-1 text-center flex items-center justify-center gap-2"
                            color="gray"
                            onClick={() => exit()}>
                            Exit
                        </Button>
                    </StickyBottomBar></main>
            </div>
        </div>

    );
}